export const createMeter = `
    mutation createMeter($input: CreateMeterInput!) {
        createMeter(input:$input) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateMeter = `
    mutation updateMeter($input: UpdateMeterInput!) {
        updateMeter(input:$input){
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const deleteMeter = `
    mutation deleteMeter($input: DeleteMeterInput!) {
        deleteMeter(input:$input)
}`;

// FNP-665: narrow status-only activation. Use this (NOT updateMeter) to flip a meter
// DRAFT->ACTIVE. updateMeter has an owner-guard that silently no-ops for catalog
// (deploy-hook-created) meters; activateMeter has no owner guard.
export const activateMeter = `
    mutation activateMeter($id: ID!) {
        activateMeter(id: $id) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

// FNP-768: the SINGLE status-transition door. The console form's Status radio sends the
// operator's chosen target status here; billing-api owns the routing (activate/retire/deprecate
// lattice + the RETIRE open-period guard) — the client no longer re-encodes those rules. Use
// this for ANY status change from the edit form. The old narrow activateMeter/retireMeter
// mutations are superseded for the form path (kept as backend ops but no longer called from the
// removed row-action buttons). A ->RETIRED that still has open periods fails closed with
// MeterHasOpenPeriods, surfaced via the mutation's onError.
export const setMeterStatus = `
    mutation setMeterStatus($id: ID!, $targetStatus: MeterStatus!) {
        setMeterStatus(id: $id, targetStatus: $targetStatus) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updatedByUsername
            created
            updated
        }
}`;

// FNP-748: narrow status-only RETIRE (ACTIVE|DEPRECATED->RETIRED). Like activateMeter,
// use this NOT updateMeter (no owner guard for catalog meters). The billing-api resolver
// fails closed if the meter still has open metering periods (MeterHasOpenPeriods) — the
// service's onError surfaces that message so the admin sees why a retire was blocked.
// FNP-768: superseded for the form path by setMeterStatus (kept for any direct caller).
export const retireMeter = `
    mutation retireMeter($id: ID!) {
        retireMeter(id: $id) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updatedByUsername
            created
            updated
        }
}`;
